import { render, staticRenderFns } from "./Alibaba-product-public.vue?vue&type=template&id=24de0dca&"
import script from "./Alibaba-product-public.vue?vue&type=script&lang=js&"
export * from "./Alibaba-product-public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports